module.exports = __webpack_public_path__ + "img/mimoz.f66d889f.jpg";